import { Content } from "shared/components/Content";
import { Page } from "clariah/components/Page";
import { PersonHero } from "shared/components/PersonHero";
import { Spacing } from "shared/components/Spacing";
import {
  DISCIPLINES,
  EMAIL,
  SPECIALISM,
  WEBSITE,
  translate,
} from "shared/utils/translate";

export const PersonDetailPage = ({
  _type,
  body,
  disciplines,
  email,
  footer,
  image,
  locale,
  mirrorPath,
  name,
  navigation,
  seo,
  specialism,
  titles,
  website,
}) => (
  <Page
    darkHeader
    description={seo?.description}
    footer={footer}
    footerHasBorder
    image={seo?.image}
    mirrorPath={mirrorPath}
    navigation={navigation}
    title={seo?.title || name}
  >
    <PersonHero
      image={image}
      name={name}
      titles={titles}
      type={_type}
      meta={[
        {
          title: translate(DISCIPLINES, locale),
          items: (disciplines || [])
            .filter(Boolean)
            .map(({ name }) => ({ label: name })),
        },
        {
          title: translate(SPECIALISM, locale),
          items: (specialism || [])
            .filter(Boolean)
            .map(({ name }) => ({ label: name })),
        },
        {
          title: translate(EMAIL, locale),
          items: email ? [{ label: email, href: `mailto:${email}` }] : [],
        },
        {
          title: translate(WEBSITE, locale),
          items: website ? [{ label: website, href: website }] : [],
        },
        ,
      ].filter(({ items }) => items.length)}
    />

    <Spacing>
      <Content data={body} />
    </Spacing>
  </Page>
);
